import React, { useState } from "react";
import {
    PlaydateInvite,
    ResponseType,
} from "../../../../../../gql/types";

import PlaydateInviteConfirmedRecipientView from "../../../../view/PlaydateInviteConfirmedRecipientView";
import PlaydateInviteRecipientRejectConfirmView from "../../../../view/PlaydateInviteRecipientRejectConfirmView";
import PlaydateInviteRecipientAcceptView from "../../../../view/PlaydateInviteRecipientAcceptView";
import { useSubmitPlaydateResponse } from "service/playdate/requests/useSubmitResponse";
import { useToastContext } from "contexts/ToastContext";

interface Props {
    invite: PlaydateInvite;
    onBack: () => void;
    onDataChange: (success: boolean, updatedInvite?: PlaydateInvite) => void;
    baseZIndex?: number;
    onCreateNewInvite: () => void;
}

type Stage = "viewOptions" | "confirmAccept" | "confirmReject";

const ConfirmedRecipientWorkflow: React.FC<Props> = ({
    invite,
    onBack,
    onDataChange,
    baseZIndex,
    onCreateNewInvite,
}) => {
    const [stage, setStage] = useState<Stage>("viewOptions");
    const { submitResponse, loading } = useSubmitPlaydateResponse();
    const { triggerToastEvent } = useToastContext();

    const isEditing = !!invite.viewerResponse;

    const onCompletion = (success: boolean, updatedInvite?: PlaydateInvite) => {
        if (!success) {
            triggerToastEvent();
        }

        if (success) {
            onDataChange(success, updatedInvite);
        }
    }

    const handleSubmit = async (type: ResponseType, message: string) => {
        await submitResponse({
            invite,
            userSelection: [],
            responseType: type,
            message: message,
            isEditing: isEditing,
            onCompletion: onCompletion,
        });
    };

    // ---------- View Logic ----------
    if (stage === "confirmAccept") {
        return (
            <PlaydateInviteRecipientAcceptView
                message={""}
                onBack={() => setStage("viewOptions")}
                onBackToDetails={() => setStage("viewOptions")}
                onSubmitConfirm={(msg) => handleSubmit(ResponseType.Accept, msg)}
                baseZIndex={baseZIndex}
                loading={loading}
            />
        );
    }

    if (stage === "confirmReject") {
        return (
            <PlaydateInviteRecipientRejectConfirmView
                message={""}
                onBack={() => setStage("viewOptions")}
                onBackToDetails={() => setStage("viewOptions")}
                onSubmitCancel={(msg) => handleSubmit(ResponseType.Reject, msg)}
                baseZIndex={baseZIndex}
                loading={loading}
            />
        );
    }

    return (
        <PlaydateInviteConfirmedRecipientView
            invite={invite}
            onBack={onBack}
            baseZIndex={baseZIndex}
            onAccept={() => setStage("confirmAccept")}
            onReject={() => setStage("confirmReject")}
            onCreate={onCreateNewInvite}
        />
    );
};

export default ConfirmedRecipientWorkflow;
